import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideNavToggleService {
  private storage = sessionStorage;
  private drawer: MatDrawer;
  private isOpen: boolean = true;
  private STORAGE: string = "SiDEN@v";

  private sideNavOpen = new BehaviorSubject<boolean>(false);

  constructor() {
    let jsonString = this.storage.getItem(this.STORAGE);
    if (jsonString == null) {
      this.isOpen = false;
    } else {
      this.isOpen = JSON.parse(jsonString) === true ? true : false;
    }
  }

  public GetSideNav(callback: Function) {
    return this.sideNavOpen.subscribe((val) => {
      if (callback != null) {
        callback(val);
      }
    });
  }

  setDrawer(drawer: MatDrawer) {
    this.drawer = drawer;
  }

  toggle(): void {
    this.drawer.toggle();
    this.isOpen = this.drawer.opened;
    this.storage.setItem(this.STORAGE, JSON.stringify(this.isOpen));
    this.sideNavOpen.next(this.isOpen);
    window.dispatchEvent(new Event('resize'));
  }

  openOrClosed(): boolean {
    return this.isOpen;
  }
}
